import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealerFotaApprovedFilesComponent } from './dealer-fota-approved-files.component';

const routes: Routes = [
  {
    path: 'dealer-fota-approved-files',
    component: DealerFotaApprovedFilesComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DealerFotaApprovedFilesPageRoutingModule {}
